export let life = {};
export let event = {
  // 点击确认
  confirmClick() {
    this.methods('confirm');
  }
};
export let watch = {};
